import { howItWorksSteps } from './data';

export default function HowItWorksContent() {
    return (
        <div>
            <h2 className="text-2xl font-bold leading-[1.3] tracking-[-0.5px] text-center text-foreground sm:text-[28px] lg:text-[36px]">
                How It Works
            </h2>

            <div className="relative mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2">
                {howItWorksSteps.map((step, i) => (
                    <div key={i} className="relative">
                        {/* Card */}
                        <div className="relative rounded-2xl bg-white p-6 shadow-[0_2px_12px_rgba(0,0,0,0.06)] sm:p-8">
                            <h3 className="text-lg font-bold text-foreground sm:text-xl">{step.title}</h3>
                            <p className="mt-2 text-sm leading-relaxed text-text-light sm:text-[15px]">
                                {step.description}
                            </p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
